import React from 'react';

import { Button, CircleIconColorType, IconType } from 'ui/component';
import { HomeCard } from '../home-card';
import classNames from './EABD2HomeCardBack.module.scss';

export interface HomeCardBackProps
  extends Readonly<{
    icon: IconType;
    iconColor: CircleIconColorType;
    empasized: string;
    description: string;
    title: string;
    onButtonPress: () => void;
    style?: React.CSSProperties;
  }> {}

export const HomeCardBack = React.memo<HomeCardBackProps>((props) => {
  const { icon, iconColor, empasized, description, title, onButtonPress, style } = props;

  const TextCallback = React.useCallback(() => {
    return (
      <p className={classNames.text}>
        <span className={classNames.emphasized}>{empasized}</span>
        <span>&nbsp;</span>
        <span>{description}</span>
      </p>
    );
  }, [empasized, description]);

  const ButtonCallback = React.useCallback(() => {
    return <Button text={'Discover more'} onPress={onButtonPress} />;
  }, [onButtonPress]);

  const SmallTextCallback = React.useCallback(() => {
    return <p className={classNames.smallText}>{title}</p>;
  }, [title]);

  return (
    <HomeCard
      icon={icon}
      iconColor={iconColor}
      shouldUseIconOutlineStyle={true}
      textElementRenderer={TextCallback}
      buttonElementRenderer={ButtonCallback}
      smallTextElementRenderer={SmallTextCallback}
      isFrontSide={false}
      style={style}
    />
  );
});
